import { Navigate } from 'react-router-dom';
import { isOmegaAdmin } from '@/features/omega/adminMode';
import { Breadcrumbs } from '@/features/omega/Breadcrumbs';
import { DecisionsTile } from '@/features/omega/dashboard/tiles/DecisionsTile';

export function OmegaDecisionsPage() {
  if (!isOmegaAdmin()) return <Navigate to="/" replace />;
  return (
    <div className="omega-shell flex flex-col gap-5 pb-8">
      <Breadcrumbs
        crumbs={[{ label: 'OMEGA', to: '/omega' }, { label: 'Decisions' }]}
      />
      <h1 className="text-xl font-semibold text-ink">Pending Decisions</h1>
      <DecisionsTile />
    </div>
  );
}
